<template>
	<el-card shadow="never" class="aui-card--fill">
		<el-row style="background-color: #F3F4F4;">
			<el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />
				任务详情
			</el-col>
			<el-col :xs="24" :md="18">
				<el-form :inline="true" :model="dataForm" style="text-align: right;">

					<el-form-item><el-button v-if="$hasPermission('plat:plattask:checked') && role=='OPERATE'" v-show="dataForm.status===1" type="primary" @click="dataFormSubmitHandle('2',dataForm.id)">审核并接受</el-button></el-form-item>
					<el-form-item><el-button v-if="$hasPermission('plat:plattask:checked') && role!='OPERATE'" v-show="dataForm.status===1" type="primary" @click="dataFormSubmitHandle('1',dataForm.id)">通过审核</el-button></el-form-item>
					<el-form-item><el-button v-if="$hasPermission('plat:plattask:checked')" v-show="dataForm.status===1" type="danger" style="background-color: thistle" @click="dataFormSubmitHandle('0',dataForm.id)">驳回</el-button></el-form-item>
					<el-form-item><el-button v-if="$hasPermission('plat:plattask:close')" v-show="dataForm.status===2" type="primary" @click="dataFormCloseHandle(dataForm.id)">关闭任务</el-button></el-form-item>
					<el-form-item><el-button class="refreshBtn" style="left: 500px;" type="info" @click="getInfo()">刷新</el-button></el-form-item>
					<el-form-item><el-button class="refreshBtn" style="left: 500px;" type="info" @click="$router.go(num)">返回列表</el-button></el-form-item>
				</el-form>
			</el-col>
		</el-row>
		<div style="padding: 50px;">
		<el-form :model="ruleForm" ref="ruleForm" :rules="rules" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
			<el-row>
				<el-col :md="24" :lg="6">
					<el-form-item label="任务大类" prop="taskType"><ren-select v-model="dataForm.taskType" :isDisabled="true" dict-type="taskType" readonly="true"></ren-select></el-form-item>
				</el-col>
			</el-row>
		    <el-form-item label="任务简述" prop="taskDesc">
		        <el-input v-model="dataForm.taskDesc" rows="2" style="width: 60%;" placeholder="任务简述" disabled="disabled"></el-input>
		    </el-form-item>
		    <el-form-item label="验收标椎" prop="taskRequire">
		        <el-input type="textarea" rows="4" style="width: 70%;" v-model="dataForm.taskRequire" placeholder="验收标椎" disabled="disabled"></el-input>
		    </el-form-item>

		    <el-row>
				<el-col :span="6">
				    <el-form-item label="需求人数" prop="requirePerson">
				        <el-input style="width: 95%;" v-model="dataForm.requirePerson" placeholder="需求人数" disabled="disabled"><i slot="suffix" style="font-style:normal;margin-right: 10px;">人</i></el-input>

				    </el-form-item>
				</el-col>
		        <el-col :span="6">
		            <el-form-item label="预算" prop="budget">
		                <el-input style="width: 95%;" v-model="dataForm.budget" placeholder="预算" disabled="disabled"><i slot="suffix" style="font-style:normal;margin-right: 10px;">元</i></el-input>
		            </el-form-item>
		        </el-col>
		        <el-col :span="6">
		            <el-form-item label="合同编号" prop="contractCode">
		                <el-input style="width: 95%;" v-model="dataForm.contractCode" placeholder="合同编号" disabled="disabled"></el-input>
		            </el-form-item>
		        </el-col>
		    </el-row>
		    <el-form-item label="任务周期" prop="startDate">
				<el-date-picker v-model="dataForm.startDate" disabled="disabled" start-placeholder="开始日期" align="right" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:SS"></el-date-picker>
				  ~
				<el-date-picker v-model="dataForm.endDate" disabled="disabled" end-placeholder="结束日期" align="right"  type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:SS"></el-date-picker>
		    </el-form-item>

		</el-form>

		<el-row style="border-top: 5px solid #F3F4F4;" v-if="dataForm.acceptDTOList.length > 0">
			<div style="font-size: 14px;font-weight: bold;color: #333333;line-height: 40px;">任务执行情况</div>
			<el-table :data="dataForm.acceptDTOList" style="width: 100%;">
			    <el-table-column label="序号" type="index" width="50" align="center">
			    	<template slot-scope="scope">
			    		<span>{{scope.$index + 1 }}</span>
			    	</template>
			    </el-table-column>
				<el-table-column prop="publishName" label="发布方" header-align="center" align="center"></el-table-column>
			    <el-table-column prop="contractCode" label="个人合同编号" header-align="center" align="center"></el-table-column>
			    <el-table-column prop="assignee" label="被分配方" header-align="center" align="center"></el-table-column>
			    <el-table-column prop="realName" label="接受方" header-align="center" align="center"></el-table-column>
			    <el-table-column prop="money" label="支付金额（元）" header-align="center" align="center">
					<template slot-scope="scope">
						{{Number(scope.row.money).toFixed(2)}}
					</template>
				</el-table-column>

				<el-table-column prop="finishProofPath" label="完工证明" header-align="center" align="center">
					<template slot-scope="scope">
						<el-button type="primary" v-if="scope.row.finishProofPath!=null && scope.row.finishProofPath!=''" @click="yulan(scope.row)">查看</el-button>
					</template>
				</el-table-column>

				<el-table-column prop="acceptDate" label="操作日期" header-align="center" align="center"></el-table-column>

				<el-table-column prop="status" label="子任务状态" header-align="center" align="center">
					<template slot-scope="scope">
						{{ $getDictLabel("acceptTaskStatus", scope.row.status) }}
					</template>
				</el-table-column>
			</el-table>
		</el-row>

		<el-row style="border-top: 5px solid #F3F4F4;">
			<div style="font-size: 14px;font-weight: bold;color: #333333;line-height: 40px;">任务状态</div>
			<div style="line-height: 25px;padding: 10px 0;font-size: 12px;">
				<p style="margin: 0;">

					任务发布编号<span style="margin-left: 30px;">{{dataForm.taskCode}}</span>
					</p>
					<p style="margin: 0;line-height: 50px;border-bottom:1px solid #F3F4F4;" v-for="(value,key) in dataForm.processDTOList" :key="key">
						<!-- <span style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span> -->
						{{value.createDate}}
						<span style="margin-left: 40px;">{{value.operation}}</span>
						<span style="margin-left: 40px;">{{value.content}}</span>
						</p>
			</div>
		</el-row>

		</div>

		<el-dialog
				title="查看"
				:visible.sync="is_show"
				:before-close="handleClose">
			<div class="el-upload-list-wrap-my">
				<el-upload
						action=""
						accept="image/*,application/pdf,application/zip"
						list-type="picture-card"
						:file-list="fileList"
						class="imgHide"
				>
					<i slot="default" class="el-icon-plus"></i>
					<div slot="file"  slot-scope="{file}">
						<img
								v-if="showPdf(file.url)"
								class="el-upload-list__item-thumbnail"
								src="../../../assets/img/pdf.png" alt=""
						>
						<img
								v-else-if="showZip(file.url)"
								class="el-upload-list__item-thumbnail"
								src="../../../assets/img/zip.jpg" alt=""
						>
						<img
								v-else
								class="el-upload-list__item-thumbnail"
								:src="file.url" alt=""
						>
						<span class="el-upload-list__item-actions">
										<span
												v-if="showPdf(file.url)"
												class="el-upload-list__item-preview"
												@click="pdfPreview(file.url)"
										>
															  <i class="el-icon-zoom-in"></i>
															</span>
											<span
													v-else-if="showZip(file.url)"
													class="el-upload-list__item-preview"
													@click="zipPreview(file.url)"
											>
															  <i class="el-icon-download"></i>
															</span>
											<span
													v-else
													class="el-upload-list__item-preview"
													@click="handlePictureCardPreview(file)"
											>
															  <i class="el-icon-zoom-in"></i>
															</span>
						</span>
					</div>

				</el-upload>

				<el-dialog :visible.sync="previewPicDialog" append-to-body>
					<img width="100%" :src="dialogImageUrl" alt="">
				</el-dialog>
			</div>
			<span slot="footer" class="dialog-footer">
						<el-button @click="is_show = false">关 闭</el-button>
			  </span>
		</el-dialog>
	</el-card>
</template>

<script>
import debounce from 'lodash/debounce'
import Cookies from 'js-cookie'
import { Loading } from 'element-ui'
import { addDynamicRoute } from '@/router'

export default {
  data () {
    return {
      rules: {
        optionCheck: [
          { type: 'array', required: true, message: '请勾选我已详细阅读并同意', trigger: 'change' }
        ]
      },
      num: -1,

        fileList: [],
      is_show: false,
      dialogVisible: false,
      visible: false,
      readonly: true,
      optionCheck: '', // 同意协议按钮
      ruleForm: {
        optionCheck: []
      },
      role: '',
      dataForm: {
        id: '',
        taskDesc: '',
        taskRequire: '',
        requirePerson: '',
        budget: '',
        contractCode: '',
        startDate: '',
        endDate: '',
        status: '',
        taskCode: '',
        processDTOList: [],
        acceptDTOList: []
      },
        previewPicDialog : false,
        dialogImageUrl : "",
    }
  },
  created () {
    this.dataForm.id = this.$route.params.id || ''
    this.num = this.$route.params.num || -1
    this.init()
    this.role = Cookies.get('admin_role')
  },
  computed: {},
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      let loadingInstance = Loading.service({})
      this.$http.get(`/sys/plat/task/getTickTaskMess?id=${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message({
						  message: res.msg,
						  type: 'error',
						  duration: 500,
						  onClose: () => {
              loadingInstance.close()
              this.$router.back(-1)
						  }
          })
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
					  loadingInstance.close()
        })
      }).catch(() => {
      })
    },
    dataFormCloseHandle: debounce(function (id) {
			  let _this = this
			  let submitForm = {}
			  submitForm.id = id
			  this.$http.post('/sys/plat/task/close?id=' + id, submitForm).then(({ data: res }) => {
			    if (res.code !== 0) {
			      return this.$message.error(res.msg)
			    }
			    this.$message({
			      message: this.$t('prompt.success'),
			      type: 'success',
			      duration: 500,
			      onClose: () => {
			  		this.getInfo()
			      }
			    })
			  }).catch(() => {})
    }),
    // 表单提交
    dataFormSubmitHandle: debounce(function (inStatus, id) {
			  let _this = this
			  this.$prompt('请输入审核理由', '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消'
			  }).then(({ value }) => {
        let status = inStatus
        if (inStatus == 2) {
          status = 1
        }
			    this.$http.post('/sys/plat/task/audit?inStatus=' + status + '&content=' + value + '&id=' + id, {
			      headers: {
			        'content-type': 'application/json;charset=utf-8'
			      }
			    }).then(({ data: res }) => {
			      if (res.code !== 0) {
			        return this.$message.error(res.msg)
			      }
			      this.$message({
			        message: this.$t('prompt.success'),
			        type: 'success',
			        duration: 500,
			        onClose: () => {
              // if(inStatus == 2){
              // 	// let submitForm = {}
              // 	// submitForm.taskId = id
              // 	// this.$http.post('/sys/plat/task/accept', submitForm).then(({data: res}) => {
              // 	//     if (res.code !== 0) {
              // 	//         return this.$message.error(res.msg)
              // 	//     }
              // 	// }).catch(() => {
              // 	// })
              // }
              this.getInfo()
			        }
			      })
			    }).catch(() => {})
			  })
    }),
    yulan (data) {
        let fileUrl ;
        if(data.finishProofPath){
            fileUrl = data.finishProofPath.split(',')
        }else if(data.finishProofPath2){
            fileUrl = data.finishProofPath2.split(',')
        }else{
            fileUrl = []
        }
        this.fileList = fileUrl.map(item=>{
            return {
                name:'',
                url:item
            }
        });
        this.is_show = true
    },
      handleClose(){
          this.is_show = false;
      },
      showPdf(url){
          if(url.split('.')[url.split('.').length-1].indexOf('pdf')>-1){
              return true
          }else{
              return false
          }
      },
      showZip(url){
          if(url.split('.')[url.split('.').length-1].indexOf('zip')>-1 || url.split('.')[url.split('.').length-1].indexOf('rar')>-1){
              return true
          }else{
              return false
          }
      },
      zipPreview(url){
          window.open(url)
      },
      pdfPreview(url){
          window.open(url)
      },
      handlePictureCardPreview(file){
          this.previewPicDialog = true;
          this.dialogImageUrl = file.url;
      },
  }
}
</script>
<style lang="scss" >
	.el-upload-list-wrap-my  .el-upload-list--picture-card{
		margin: 0;
		display: inline;
		vertical-align: top;
	}
	.el-upload-list-wrap-my .el-upload-list__item:first-child{
		margin-top: 0px !important;
	}
	.imgHide .el-upload--picture-card {
		display: none;
	}
	.uploadimgage{
		text-align: center;
		margin-top: 5px;
		display: block;
	}
</style>
